import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/** Public anon credentials — safe in the browser. Used when deploy env is missing/mangled. */
const FALLBACK_URL = 'https://mizsqcqxnurqdzqauqfg.supabase.co';
const FALLBACK_ANON_KEY = 'sb_publishable_0lFLqGNS3X_jGGLDqjQnFA_6upjHJQj';

function cleanEnv(value: unknown): string {
  return String(value ?? '')
    .trim()
    .replace(/^["']|["']$/g, '');
}

function resolveHttpUrl(raw: string, fallback: string): string {
  if (/^https?:\/\/.+/i.test(raw)) return raw;
  // Recover if a build tool path.join'd the project root onto the URL
  const match = raw.match(/https?:\/+[\w.-]+\.supabase\.co\/?/i);
  if (match) return match[0].replace(/^(https?:)\/+/, '$1//').replace(/\/$/, '');
  return fallback;
}

const supabaseUrl = resolveHttpUrl(
  cleanEnv(import.meta.env.VITE_PUBLIC_SUPABASE_URL),
  FALLBACK_URL,
);
const supabaseAnonKey =
  cleanEnv(import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY) || FALLBACK_ANON_KEY;

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey);
